/* src/app/zest/zest.component.scss */
.zest-wrapper {
  display: flex;
  min-height: 100%;
  background-color: #3c3446;
  color: white;
}
.zest-wrapper .zest-load-wrapper {
  margin: auto;
  width: 50%;
  padding: 20px;
}
.zest-wrapper .zest-load-wrapper .spinner-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  animation: fadein 0.5s;
  margin-top: 20px;
}
.zest-wrapper .zest-load-wrapper h1 {
  font-size: 30px;
  font-weight: 900;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.03;
  text-align: center;
  letter-spacing: 1px;
  padding-left: 10px;
  display: inline-block;
  color: #f2eee7;
}
/*# sourceMappingURL=zest.component.css.map */
